import { reactive, computed } from 'vue';
import productService from '@/services/productService';
import pendampingService from '@/services/pendampingService';
import sourceService from '@/services/sourceService';
import memberService from '@/services/memberService';
import orderService from '@/services/orderService';

const state = reactive({
    products: [],
    pendampings: [],
    sources: [],
    members: [],
    orders: [],
    isLoaded: false,
    isLoading: false,
    newMemberId: null
});

export const useDataStore = () => {
    const setNewMemberId = (id) => {
        state.newMemberId = id;
    };

    const clearNewMemberId = () => {
        state.newMemberId = null;
    };
    const loadAllData = async (force = false) => {
        if (!force && (state.isLoaded || state.isLoading)) return;

        state.isLoading = true;
        try {
            // Use Promise.allSettled to prevent one failure from breaking everything
            const results = await Promise.allSettled([
                productService.getProducts({ limit: 10000 }),
                pendampingService.getPendampings({ limit: 10000 }),
                sourceService.getSources({ limit: 10000 }),
                memberService.getMembers({ limit: 10000 }),
                orderService.getOrders({ limit: 1000 })
            ]);

            // Process each result individually
            if (results[0].status === 'fulfilled') {
                state.products = results[0].value?.items || results[0].value || [];
            }
            if (results[1].status === 'fulfilled') {
                state.pendampings = results[1].value?.items || results[1].value || [];
            }
            if (results[2].status === 'fulfilled') {
                state.sources = results[2].value?.items || results[2].value || [];
            }
            if (results[3].status === 'fulfilled') {
                state.members = results[3].value?.items || results[3].value || [];
                if (state.members.length > 0) {
                    console.log('Store - Member keys:', Object.keys(state.members[0]));
                }
            }
            if (results[4].status === 'fulfilled') {
                state.orders = results[4].value?.items || results[4].value || [];
            }

            state.isLoaded = true;
        } catch (error) {
            console.error("Failed to pre-load data:", error);
        } finally {
            state.isLoading = false;
        }
    };

    const refreshData = async (type) => {
        try {
            if (type === 'products') {
                const res = await productService.getProducts({ limit: 10000 });
                state.products = res?.items || res || [];
            } else if (type === 'pendampings') {
                const res = await pendampingService.getPendampings({ limit: 10000 });
                state.pendampings = res?.items || res || [];
            } else if (type === 'sources') {
                const res = await sourceService.getSources({ limit: 10000 });
                state.sources = res?.items || res || [];
            } else if (type === 'members') {
                const res = await memberService.getMembers({ limit: 10000, _t: Date.now() });
                state.members = res?.items || res || [];
                console.log(`Members refreshed. Count: ${state.members.length}`);
                if (state.members.length > 0) {
                    console.log('Refresh - Member keys:', Object.keys(state.members[0]));
                }
            } else if (type === 'orders') {
                const res = await orderService.getOrders({ limit: 1000 });
                state.orders = res?.items || res || [];
            }
        } catch (error) {
            console.error(`Failed to refresh ${type}:`, error);
        }
    };

    return {
        state,
        loadAllData,
        refreshData,
        setNewMemberId,
        clearNewMemberId,
        products: computed(() => state.products),
        pendampings: computed(() => state.pendampings),
        sources: computed(() => state.sources),
        members: computed(() => state.members),
        orders: computed(() => state.orders),
        isInitialLoadComplete: computed(() => state.isLoaded)
    };
};
